import styled from 'styled-components'

export const Root = styled.div`
  display: flex;
  align-items: center;
  gap: 11px;
`

export const Select = styled.div`
  width: 136px;
`
